import React from "react";
import { SovosButton, SovosBox, SovosChipFilter } from "mosaic-react";
import { BorderColor, ModeEdit } from "mosaic-react-icons";
import { useTheme } from "mosaic-react/styles";

const ImportProfilesEditModeButtons = (props) => {
    const { editMode, setEditMode, onClickSave, onClickCancel, list, rawDataEdit, i18n } = props;
    const theme = useTheme();

    return (
        <SovosBox sx={{ display: "flex", alignItems: "center" }}>
            {editMode && (
                <SovosChipFilter
                    sx={{
                        fontSize: "small",
                        height: 25,
                        marginRight: 2,
                        background: theme.palette.error.light,
                        padding: "6px",
                    }}
                    icon={<ModeEdit fontSize={"small"} />}
                    label={i18n`Edit Mode`}
                />
            )}
            {!editMode && (
                <SovosButton
                    disabled={!rawDataEdit || !list?.length}
                    variant={"text"}
                    startIcon={<BorderColor />}
                    onClick={() => setEditMode(true)}
                    tooltipText={
                        !rawDataEdit || !list?.length
                            ? i18n`Edit mode is only available when data is loaded and editing is permitted`
                            : i18n`Activate Edit Mode`
                    }
                >
                    {i18n`Edit Mode`}
                </SovosButton>
            )}
            {editMode && (
                <>
                    <SovosButton onClick={onClickSave}>{i18n`Save`}</SovosButton>
                    <SovosButton
                        variant={"outlined"}
                        sx={{ marginLeft: "8px" }}
                        onClick={onClickCancel}
                    >
                        {i18n`Cancel`}
                    </SovosButton>
                </>
            )}
        </SovosBox>
    );
};

export default ImportProfilesEditModeButtons;
